import { useState } from "react";
import { marked } from "marked";
import { InfoIcon } from "./InfoIcon";

interface HelpTipProps {
  content: string;
}

export function HelpTip({ content }: HelpTipProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="btn-help-tip" onClick={() => setOpen(true)} aria-label="Help">
        <InfoIcon />
      </button>

      {open && (
        <div className="help-tip-overlay">
          <div className="help-tip-modal">
            <div className="header-row">
              <h1 className="header-title">Help</h1>
              <button onClick={() => setOpen(false)} className="btn-close" aria-label="Close">&times;</button>
            </div>
            {/* content is static dev-authored help text, not user input */}
            <div
              className="help-tip-content"
              dangerouslySetInnerHTML={{ __html: marked.parse(content) as string }}
            />
          </div>
        </div>
      )}
    </>
  );
}
